import { Container, Box, Text } from '@mantine/core'
import Seo from '../_Seo'
import SettingsContent from '../_SettingsContent'
import { useI18n } from '../_i18n'
import { TILE } from '../stations/_tiles'

// Standalone /settings page (also available as a topnav overlay). The controls
// live in the shared SettingsContent component, rendered inside the app's navy
// list-card frame (TILE.mid header band over a TILE.dark body) so it matches the
// overlay and the rest of the site.
export default function SettingsPage() {
  const { t } = useI18n()
  return (
    <>
      <Seo title={t('settings')} description={t('settings_seo_description')} noindex />
      <Container size="sm" py="xl">
        <Box style={{ borderRadius: 12, overflow: 'hidden', background: TILE.dark }}>
          <Text
            px="md"
            py={9}
            fw={700}
            tt="uppercase"
            c="#fff"
            fz="0.85rem"
            style={{ letterSpacing: 0.6, background: TILE.mid }}
          >
            {t('settings')}
          </Text>
          <Box p="lg">
            <SettingsContent />
          </Box>
        </Box>
      </Container>
    </>
  )
}
